import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=ff8a69fc"
import script from "./BranchList.vue?vue&type=script&lang=js"
export * from "./BranchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports